import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';

const api = axios.create();

export const postUpdateProfileUser = (body = {}) =>
  api
    .post('/api/social/user/profile/update', qs.stringify(body), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
